import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@material-ui/core/styles';

import { paramConverter } from 'modules/common';
import { adblockGraph } from 'lib/api/time';
import ContentsWrap from 'components/molecules/ContentsWrap';
import Highchart from 'components/organisms/Chart/Highchart';
import PropTypes from 'prop-types';
const AdblockPieGraph = (props) => {
  const { t } = useTranslation();
  const { params } = props;
  const theme = useTheme();

  const pieGraphOption = {
    '01': {
      title: t('전체'),
      color: ['#A6A6A6', '#EB483A'],
    },
    '02': {
      title: 'Device별',
      color: ['#EB483A', '#343434'],
    },
    '03': {
      title: 'Browser별',
      color: [
        '#0c87DA',
        '#EB483A',
        '#19CE60',
        '#A6A6A6',
        '#343434',
        '#0FADE8',
        '#E28E22',
        '#FFDC00',
        '#4867AA',
      ],
    },
    '04': {
      title: 'OS별',
      color: [
        '#343434',
        '#0c87DA',
        '#4867AA',
        '#A6A6A6',
        '#FFDC00',
        '#EB483A',
        '#0FADE8',
      ],
    },
  };

  //하이차트 기본설정
  const graphTitle = t(pieGraphOption[params.group].title + ' 애드블록 사용자');
  const initOptions = {
    chart: {
      type: 'pie',
      backgroundColor: theme.palette.common.bgColor,
    },
    title: {
      text: graphTitle,
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      type: 'category',
    },
    accessibility: {
      point: {
        valueSuffix: '%',
      },
    },
    legend: {
      reversed: true,
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        //colors: [],
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.percentage:.1f} %',
        },
        showInLegend: true,
      },
    },
    series: [],
  };

  const [graphOption, setGraphOption] = useState(initOptions);
  const [graphLoading, setGraphLoading] = useState(true);

  useEffect(() => {
    setGraphLoading(true);
    adblockGraph({ ...paramConverter(params), group: params.group })
      .then((response) => {
        const { data } = response.data;

        makeGraphData(data.pie);
      })
      .catch((error) => {})
      .finally(() => {
        setGraphLoading(false);
      });
    //eslint-disable-next-line
  }, [params]);

  /**
   * 그래프용 데이터 가공
   */
  const makeGraphData = useCallback(
    (graphData) => {
      let tmpSeries = [];
      graphData['INFW_CNT'].data.forEach((item) =>
        tmpSeries.push({
          name: item.name,
          y: parseInt(item.val),
        })
      );
      setGraphOption({
        ...graphOption,
        plotOptions: {
          pie: {
            ...graphOption.plotOptions.pie,
            colors: pieGraphOption[params.group].color,
          },
        },
        title: {
          text: graphTitle,
        },
        series: [
          {
            name: 'User',
            colorByPoint: true,
            data: tmpSeries,
          },
        ],
      });
    },
    [graphTitle, params, graphOption, pieGraphOption]
  );

  return (
    <>
      <ContentsWrap contentsCount={1}>
        <Highchart options={graphOption} loading={graphLoading} />
      </ContentsWrap>
    </>
  );
};

const equalComparison = (prevProps, nextProps) => {
  if (JSON.stringify(prevProps.params) !== JSON.stringify(nextProps.params)) {
    return false;
  }
};

AdblockPieGraph.propTypes = {
  params: PropTypes.object.isRequired,
};
export default React.memo(AdblockPieGraph, equalComparison);
